import { EnergySavingUI } from "./EnergySavingUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { useYourekoLabels } from "@/components/EnergySaving/useYourekoLabels";

export function EnergySaving({ product }: Pick<StandardProps, "product">) {
  const { variant } = useVariant(product);
  const { sellingProductType } = product;

  const { result, refetch, isLoading, isDisabled } = useYourekoLabels({
    sellingProductType,
    variantTitle: variant.title,
  });

  const isButtonVisible =
    !isLoading && !isDisabled && result && result.canButtonBeShown;

  if (!isButtonVisible) {
    return null;
  }

  return (
    <EnergySavingUI
      energyCostSavingUnformatted={result.energyCostSavingUnformatted}
      numberOfAlternatives={result.numberOfAlternatives}
      medalRatingText={result.medalRatingText}
      refetch={refetch}
    />
  );
}
